import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getMe } from "../utils/services/loginUser";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

//image
import logoDark from "../assets/image/logo.png";
import logoEE from "../assets/image/logoEE.png";

// componentes
import ModalConfigLogistics from "../pages/AboutEvent/configLogistic";
import ModalConfigEventPortal from "../pages/AboutEvent/eventsPortal/ModalConfigEventPortal";
import ModalConfigApp from "../pages/AboutEvent/Dashboard/ModalConfigApp";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

const SidebarContent = (props) => {
  const ref = useRef();
  // section dropdowns (exclusão mútua via string key)
  const [openSection, setOpenSection] = useState(null);
  const [collapseTransfer, setCollapseTransfer] = useState(false);
  const [dropTemplates, setDropTemplates] = useState(false);
  // product dropdowns (exclusão mútua via string key)
  const [openProduct, setOpenProduct] = useState(null);
  const location = useLocation();
  const [logoSmall, setLogoSmall] = useState("");
  const [logoLarge, setLogoLarge] = useState("");
  const [profile, setProfile] = useState("");
  // modal de logistica
  const [modalConfigLogistic, setModalConfigLogistic] = useState(false);
  const [modalConfigEventPortal, setModalConfigEventPortal] = useState(false);
  const [modalConfigPortal, setModalConfigPortal] = useState(false);
  const [modalApp, setModalApp] = useState(false);

  let navigate = useNavigate();

  // fecha todos os produtos e seções, abre o produto selecionado
  function toggleProduct(product) {
    setOpenProduct((prev) => (prev === product ? null : product));
    setOpenSection(null);
    setCollapseTransfer(false);
    setDropTemplates(false);
    props.closeMenuConfig();
    props.closeMenuContracts();
    props.closeMenuApp();
  }

  function closeDrops(e) {
    if (e === "transfer") {
      setOpenSection("logistica");
      setCollapseTransfer((prev) => !prev);
      setDropTemplates(false);
      setOpenProduct(null);
      props.closeMenuConfig();
      props.closeMenuContracts();
      props.closeMenuApp();
      return;
    }

    if (e === "templates") {
      setDropTemplates((prev) => !prev);
      setCollapseTransfer(false);
      props.closeMenuConfig();
      props.closeMenuContracts();
      props.closeMenuApp();
      return;
    }

    setCollapseTransfer(false);
    setDropTemplates(false);

    if (e === "configuration") {
      props.state.menu.menuConfig
        ? props.closeMenuConfig()
        : props.openMenuConfig();
      props.closeMenuContracts();
      props.closeMenuApp();
      setOpenSection(null);
      return;
    }

    if (e === "contract") {
      props.state.menu.menuContract
        ? props.closeMenuContracts()
        : props.openMenuContracts();
      props.closeMenuConfig();
      props.closeMenuApp();
      setOpenSection(null);
      return;
    }

    if (e === "applications") {
      props.openMenuContracts();
      props.state.menu.menuApp ? props.closeMenuApp() : props.openMenuApp();
      props.closeMenuConfig();
      setOpenSection(null);
      return;
    }

    if (e) {
      setOpenSection((prev) => (prev === e ? null : e));
      // seções de topo são exclusivas com produtos
      if (e === "logistica" || e === "documents") setOpenProduct(null);
    } else {
      setOpenSection(null);
    }
    props.closeMenuConfig();
    props.closeMenuContracts();
    props.closeMenuApp();
  }

  function tToggle() {
    //props.setViewMenu(!props.viewMenu)
    if (props.state.layout_manager.drawer_openend) {
      props.closeNavBar();
    } else {
      props.openNavBar();
    }
  }

  function checkItemMenuExists(menuOption) {
    const result =
      props?.state?.global_user_data?.data?.foundProducts?.filter(
        (item) => item.name === menuOption,
      ).length > 0 && checkUserPermission(menuOption);
    return result;
  }

  function checkUserPermission(screen) {
    if (props?.state?.global_user_data?.data?.theme[0]?.isDefault) {
      return true;
    }

    if (props?.state?.global_user_data?.data?.theme[0]?.scrp?.length > 0) {
      return (
        props.state.global_user_data.data.theme[0].scrp.filter(
          (item) => item.name === screen, //&& item.act.includes("R")
        ).length > 0
      );
    }
    return false;
  }

  // console.log(location.state.event.product);
  function checkProductExists(product) {
    const search =
      location?.state?.event?.product?.filter((e) => e.name === product) ?? [];

    return !!search[0];
  }

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
    setLogoSmall(props?.state?.global_user_data?.data?.theme[0]?.logosmall);
    setLogoLarge(props?.state?.global_user_data?.data?.theme[0]?.logolarge);
    if (isMobile) {
      const navbar = document.getElementById("sidebar-menu");
      navbar.classList.remove("active");
      setIsMobile(false);
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   ref.current.recalculate();
  // });
  useEffect(() => {
    getProfile();
  }, []);

  async function getProfile() {
    const res = await getMe();
    if (res?.data?.id) {
      setProfile(res.data.id);
    }
  }

  //fechar o drop de app quando fechar o drop config
  useEffect(() => {
    if (!props.state.menu.menuConfig) {
      props.closeMenuApp();
    }
  }, [props.state.menu.menuConfig]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight && ref.current) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  const [isMobile, setIsMobile] = useState(false);
  const showLabels = props.state.layout_manager.drawer_openend || isMobile;

  const handleNavBar = () => {
    const navbar = document.getElementById("sidebar-menu");
    navbar.classList.toggle("active", !isMobile);
    setIsMobile(!isMobile);
  };

  // fecha o menu lateral quando estiver em modo mobile
  function closeMobileMenu() {
    if (isMobile) {
      const navbar = document.getElementById("sidebar-menu");
      navbar.classList.remove("active");
      setIsMobile(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.state.events]);
  return (
    <React.Fragment>
      {modalConfigLogistic && (
        <ModalConfigLogistics
          isOpen={modalConfigLogistic}
          toggle={() => setModalConfigLogistic(false)}
        />
      )}

      {modalApp && (
        <ModalConfigApp
          isOpen={modalApp}
          toggle={() => setModalApp(!modalApp)}
          eventId={location?.state?.event?.id}
          // jwt={jwt}
        />
      )}

      {modalConfigEventPortal && (
        <ModalConfigEventPortal
          isOpen={modalConfigEventPortal}
          toggle={() => setModalConfigEventPortal(false)}
          eventId={location?.state?.event?.id}
          contractId={props?.state?.global_user_data?.data?.theme[0].id}
        />
      )}

      <div
        style={{
          position: "inline",
          transition: "1s",
          background: "white",
          height: "100%",
        }}
      >
        <div className="h-100">
          <div style={{ maxHeight: "100%" }}>
            <div
              id="sidebar-menu"
              className={isMobile ? "mobile-menu-open" : ""}
            >
              {!isMobile && (
                <div className="sidebar-logo-container">
                  <Link to="/events" className="logo logo-dark">
                    <span className="logo-lg">
                      {!props.state.layout_manager.drawer_openend ? (
                        <img src={logoSmall || logoEE} alt="" height="20" />
                      ) : (
                        <img src={logoLarge || logoDark} alt="" height="60" />
                      )}
                    </span>
                  </Link>
                </div>
              )}
              <div onClick={() => handleNavBar()} className="div-btn-menu">
                <i
                  className={`${
                    !isMobile ? "fa fa-fw fa-bars" : "mdi mdi-close"
                  }`}
                />
              </div>
              <ul
                className="metismenu list-unstyled active"
                id="side-menu"
                style={{ marginTop: isMobile ? 70 : 0 }}
              >
                <li className="menu-title">{props.t("Menu")}</li>
                <li>
                  <Link
                    to="/events"
                    className={`waves-effect ${
                      location.pathname === "/events" ? "selected" : null
                    }`}
                    onClick={() => {
                      props.openEvent("0", "EVENTO");
                      closeDrops("");
                    }}
                  >
                    <i className="bx bx-calendar"></i>
                    {!showLabels ? null : <span>Eventos</span>}
                  </Link>
                  <Link
                    to="/users"
                    className="waves-effect"
                    style={{ display: "none" }}
                  >
                    <i className="mdi mdi-account-circle-outline"></i>
                    {!showLabels ? null : <span>Usuários</span>}
                  </Link>
                  {location?.state?.event?.id && (
                    <div
                      // className={classname("dropdown-menu", { show: events })}
                      style={{
                        marginLeft: 10,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {checkItemMenuExists("AGENDA") &&
                        (checkProductExists("APP Eventos Plus") ||
                          checkProductExists("RSVP") ||
                          checkProductExists("Distribuição de Cotas")) && (
                          <a
                            className={
                              props.state.events === "1" ? "selected" : ""
                            }
                            onClick={() => {
                              props.openEvent("1", "AGENDA");
                              closeDrops("");

                              navigate("/event/agenda", {
                                state: { ...location?.state },
                              });
                            }}
                          >
                            <i
                              className="mdi mdi-calendar-range"
                              style={{ color: "black" }}
                            />
                            {!showLabels ? null : <span>Agenda</span>}
                          </a>
                        )}
                      {(checkProductExists("Leitor de QR Code") ||
                        checkProductExists("APP Eventos Plus")) &&
                        (checkItemMenuExists("RANKING_GERAL") ||
                          checkItemMenuExists("RANKING_CONFIG")) && (
                          <>
                            <a
                              className="waves-effect"
                              onClick={() => {
                                toggleProduct("gamification");
                              }}
                            >
                              <i className="mdi mdi-podium" />
                              {!showLabels ? null : <span>Gamification</span>}
                              {openProduct === "gamification" ? (
                                <i className="bx bx-chevron-up" />
                              ) : (
                                <i className="bx bx-chevron-down" />
                              )}
                            </a>
                            {openProduct === "gamification" && (
                              <div className="submenu-tree">
                                {checkItemMenuExists("RANKING_GERAL") && (
                                  <a
                                    className={
                                      props.state.events === "17"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("17", "RANKING_GERAL");

                                      navigate("/event/ranking", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="mdi mdi-view-list" />
                                    {!showLabels ? null : (
                                      <span>Ranking Geral</span>
                                    )}
                                    {/* {isMobile && <span>Ranking Geral</span>} */}
                                  </a>
                                )}
                                {checkItemMenuExists("RANKING_CONFIG") && (
                                  <a
                                    className={
                                      props.state.events === "18"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("18", "RANKING_CONFIG");

                                      navigate("/event/ranking/settings", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="mdi mdi-cog-outline" />
                                    {!showLabels ? null : (
                                      <span>Configurações</span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      {checkItemMenuExists("GRUPOS") &&
                        (checkProductExists("APP Eventos Plus") ||
                          checkProductExists("RSVP") ||
                          checkProductExists("Match de Hospedagem") ||
                          checkProductExists(
                            "Gateway de Pagamentos (Adesão)",
                          ) ||
                          checkProductExists("Distribuição de Cotas")) && (
                          <a
                            className={
                              props.state.events === "2" ? "selected" : ""
                            }
                            onClick={() => {
                              props.openEvent("2", "GRUPOS");
                              closeDrops("");

                              navigate("/event/grupos", {
                                state: { ...location?.state },
                              });
                            }}
                          >
                            <i className="bx bxs-group" />
                            {!showLabels ? null : <span>Grupos</span>}
                          </a>
                        )}

                      {(checkItemMenuExists("VOO") ||
                        checkItemMenuExists("HOTEL") ||
                        checkItemMenuExists("TRANSFER")) &&
                        (checkProductExists("APP Eventos Plus") ||
                          checkProductExists("Inteegra MOBI") ||
                          checkProductExists("RSVP")) && (
                          <a
                            className="waves-effect"
                            onClick={() => closeDrops("logistica")}
                          >
                            <i className="mdi mdi-taxi" />
                            {!showLabels ? null : (
                              <span className="option-drop-menu">
                                Logística
                              </span>
                            )}
                            {openSection === "logistica" ? (
                              <i className="bx bx-chevron-up" />
                            ) : (
                              <i className="bx bx-chevron-down" />
                            )}
                          </a>
                        )}

                      {openSection === "logistica" && (
                        <div className="submenu-tree">
                          {/* {checkItemMenuExists("DASHBOARD TRANSFER") &&
                            (checkProductExists("APP Eventos Plus") ||
                              checkProductExists("Inteegra MOBI") ||
                              checkProductExists("RSVP")) && (
                              <a
                                className={
                                  props.state.events === "40"
                                    ? "selected waves-effect"
                                    : "waves-effect"
                                }
                                onClick={() => {
                                  props.openEvent("40");

                                  navigate("/event/logistica/dashboard", {
                                    state: { ...location?.state },
                                  });
                                }}
                              >
                                <i className="bx bxs-pie-chart-alt-2" />
                                {!showLabels ? null : (
                                  <span>Dashboard</span>
                                )}
                              </a>
                            )} */}

                          {(checkItemMenuExists("VOO") ||
                            checkItemMenuExists("HOTEL") ||
                            checkItemMenuExists("TRANSFER")) && (
                            <a
                              className={"waves-effect"}
                              onClick={() => {
                                closeMobileMenu();
                                setModalConfigLogistic(true);
                              }}
                            >
                              <i className="dripicons-gear" />
                              {!showLabels ? null : <span>Configurações</span>}
                            </a>
                          )}

                          {checkItemMenuExists("DASHBOARD TRANSFER") &&
                            checkProductExists("Inteegra MOBI") && (
                              <a
                                className={
                                  props.state.events === "40"
                                    ? "selected waves-effect"
                                    : "waves-effect"
                                }
                                onClick={() => {
                                  props.openEvent("40", "DASHBOARD TRANSFER");

                                  navigate("/event/dashboard-transfer", {
                                    state: { ...location?.state },
                                  });
                                }}
                              >
                                <i className="bx bxs-pie-chart-alt-2" />
                                {!showLabels ? null : <span>Dashboard</span>}
                              </a>
                            )}

                          {checkItemMenuExists("HOTEL") &&
                            (checkProductExists("APP Eventos Plus") ||
                              checkProductExists("Inteegra MOBI") ||
                              checkProductExists("RSVP")) && (
                              <a
                                className={
                                  props.state.events === "5"
                                    ? "selected waves-effect"
                                    : "waves-effect"
                                }
                                onClick={() => {
                                  props.openEvent("5", "HOTEL");

                                  navigate("/event/logistica/hotel", {
                                    state: { ...location?.state },
                                  });
                                }}
                              >
                                <i className="bx bxs-hotel" />
                                {!showLabels ? null : <span>Hotel</span>}
                              </a>
                            )}

                          <a
                            className="waves-effect"
                            onClick={() => {
                              closeDrops("transfer");
                            }}
                            style={{ display: "flex" }}
                          >
                            <i className="mdi mdi-car" />
                            {!showLabels ? null : (
                              <span className="option-drop-menu">Transfer</span>
                            )}
                            {collapseTransfer ? (
                              <i className="bx bx-chevron-up" />
                            ) : (
                              <i className="bx bx-chevron-down" />
                            )}
                          </a>

                          {collapseTransfer && (
                            <div className="submenu-tree">
                              {checkItemMenuExists("TRANSFER") &&
                                (checkProductExists("APP Eventos Plus") ||
                                  checkProductExists("Inteegra MOBI") ||
                                  checkProductExists("RSVP")) && (
                                  <a
                                    className={
                                      props.state.events === "4"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("4", "TRANSFER");

                                      navigate("/event/logistica/transfer", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-user-check" />
                                    {!showLabels ? null : (
                                      <span>Participantes com Transfer</span>
                                    )}
                                  </a>
                                )}

                              {checkItemMenuExists("VEICULOS") &&
                                checkProductExists("Inteegra MOBI") && (
                                  <a
                                    className={
                                      props.state.events === "39"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("39", "VEICULOS");
                                      navigate("/event/vehicles", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-car-multiple" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Veículos
                                      </span>
                                    )}
                                  </a>
                                )}
                            </div>
                          )}

                          {checkItemMenuExists("VOO") &&
                            (checkProductExists("APP Eventos Plus") ||
                              checkProductExists("Inteegra MOBI") ||
                              checkProductExists("RSVP")) && (
                              <a
                                className={
                                  props.state.events === "3"
                                    ? "selected waves-effect"
                                    : "waves-effect"
                                }
                                onClick={() => {
                                  props.openEvent("3", "VOO");

                                  navigate("/event/logistica/voo", {
                                    state: { ...location?.state },
                                  });
                                }}
                              >
                                <i className="mdi mdi-airplane" />
                                {!showLabels ? null : <span>Voo</span>}
                              </a>
                            )}
                        </div>
                      )}

                      {checkItemMenuExists("PARTICIPANTES") && (
                        <a
                          className={
                            props.state.events === "6" ? "selected" : ""
                          }
                          onClick={() => {
                            props.openEvent("6", "PARTICIPANTES");
                            closeDrops("");

                            navigate("/event/participantes", {
                              state: { ...location?.state },
                            });
                          }}
                        >
                          <i className="bx bx-user" />
                          {!showLabels ? null : <span>Participantes</span>}
                        </a>
                      )}

                      {/* Section agendamento */}
                      {checkProductExists("Agendamento") &&
                        (checkItemMenuExists("ESTOQUE") ||
                          checkItemMenuExists("RELATORIO DE AGENDAMENTOS")) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("scheduling");
                              }}
                            >
                              {props.t("Agendamentos")}
                              {openProduct === "scheduling" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "scheduling" && (
                              <div className="product-section-open">
                                {checkItemMenuExists("ESTOQUE") && (
                                  <a
                                    className={
                                      props.state.events === "37"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("37", "ESTOQUE");
                                      closeDrops("");
                                      navigate("/event/estoque", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bxl-dropbox" />
                                    {!showLabels ? null : <span>Estoque</span>}
                                  </a>
                                )}

                                {checkItemMenuExists(
                                  "RELATORIO DE AGENDAMENTOS",
                                ) && (
                                  <a
                                    className={
                                      props.state.events === "38"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "38",
                                        "RELATORIO DE AGENDAMENTOS",
                                      );
                                      closeDrops("");
                                      navigate("/event/relatorio-agendamento", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bxs-report" />
                                    {!showLabels ? null : (
                                      <span>Relatório de Agendamento</span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section App Eventos */}
                      {checkProductExists("APP Eventos Plus") &&
                        (checkItemMenuExists("CERTIFICADOS") ||
                          checkItemMenuExists(
                            "RELATORIO_PARTICIPANTES_CERTIFICADOS",
                          ) ||
                          checkItemMenuExists("DASHBOARD") ||
                          checkItemMenuExists("RELATORIO_DOCUMENTOS") ||
                          checkItemMenuExists("FEED") ||
                          checkItemMenuExists("MENU_APP") ||
                          checkItemMenuExists("NOTIFICACOES_PUSH") ||
                          checkItemMenuExists(
                            "QUESTIONARIO_RELATORIO_RESPOSTAS",
                          ) ||
                          checkItemMenuExists("SUPER_TELA") ||
                          checkItemMenuExists(
                            "UPLOADAPP_RELATORIO_PARTICIPANTES",
                          ) ||
                          checkItemMenuExists("PALESTRANTES")) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("app");
                              }}
                            >
                              {props.t("APP Eventos")}
                              {openProduct === "app" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "app" && (
                              <div className="product-section-open">
                                {(checkItemMenuExists("CERTIFICADOS") ||
                                  checkItemMenuExists(
                                    "RELATORIO_PARTICIPANTES_CERTIFICADOS",
                                  )) && (
                                  <a
                                    className="waves-effect"
                                    onClick={() => {
                                      closeDrops("certificate");
                                    }}
                                  >
                                    <i className="mdi mdi-certificate-outline" />
                                    {!showLabels ? null : (
                                      <span>Certificado</span>
                                    )}
                                    {openSection === "certificate" ? (
                                      <i className="bx bx-chevron-up" />
                                    ) : (
                                      <i className="bx bx-chevron-down" />
                                    )}
                                  </a>
                                )}
                                {openSection === "certificate" && (
                                  <div className="submenu-tree">
                                    {checkItemMenuExists("CERTIFICADOS") && (
                                      <a
                                        className={
                                          props.state.events === "8"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent("8", "CERTIFICADOS");
                                          navigate("/event/certificados", {
                                            state: { ...location?.state },
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-certificate" />
                                        {!showLabels ? null : (
                                          <span>Certificados</span>
                                        )}
                                      </a>
                                    )}

                                    {checkItemMenuExists(
                                      "RELATORIO_PARTICIPANTES_CERTIFICADOS",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "9"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "9",
                                            "RELATORIO_PARTICIPANTES_CERTIFICADOS",
                                          );
                                          navigate(
                                            "/event/certificados/relatorio",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="bx bxs-report" />
                                        {!showLabels ? null : (
                                          <span>
                                            Relatório por Participante
                                          </span>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                )}

                                {checkItemMenuExists("CONFIGURARAPP") && (
                                  <a
                                    className={
                                      props.state.events === "51"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      closeMobileMenu();
                                      setModalApp(true);
                                    }}
                                  >
                                    <i className="mdi mdi-cog-outline" />
                                    {!showLabels ? null : (
                                      <span>Configurar APP</span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("DASHBOARD") && (
                                  <a
                                    className={
                                      props.state.events === "10"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("10", "DASHBOARD");
                                      closeDrops("");
                                      navigate("/event/dashboard", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bxs-pie-chart-alt-2" />
                                    {!showLabels ? null : (
                                      <span>Dashboard</span>
                                    )}
                                  </a>
                                )}
                                {(checkItemMenuExists("RELATORIO_DOCUMENTOS") ||
                                  checkItemMenuExists(
                                    "RELATORIO_PARTICIPANTES",
                                  ) ||
                                  checkItemMenuExists(
                                    "RELATORIO_DOWNLOADS",
                                  )) && (
                                  <a
                                    className="waves-effect"
                                    onClick={() => {
                                      closeDrops("downloadDoc");
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="bx bxs-download" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Download de Documentos
                                      </span>
                                    )}
                                    {openSection === "downloadDoc" ? (
                                      <i className="bx bx-chevron-up" />
                                    ) : (
                                      <i className="bx bx-chevron-down" />
                                    )}
                                  </a>
                                )}

                                {openSection === "downloadDoc" && (
                                  <div className="submenu-tree">
                                    {checkItemMenuExists(
                                      "RELATORIO_DOCUMENTOS",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "11"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "11",
                                            "RELATORIO_DOCUMENTOS",
                                          );

                                          navigate(
                                            "/event/download/documentos",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-file-document-edit-outline" />
                                        {!showLabels ? null : (
                                          <span>Documentos</span>
                                        )}
                                      </a>
                                    )}
                                    {checkItemMenuExists(
                                      "RELATORIO_PARTICIPANTES",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "12"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "12",
                                            "RELATORIO_PARTICIPANTES",
                                          );

                                          navigate(
                                            "/event/download/relatorio/participantes",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-file-document-multiple-outline" />
                                        {!showLabels ? null : (
                                          <span>
                                            Relatório de participantes
                                          </span>
                                        )}
                                      </a>
                                    )}
                                    {checkItemMenuExists(
                                      "RELATORIO_DOWNLOADS",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "13"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "13",
                                            "RELATORIO_DOWNLOADS",
                                          );

                                          navigate(
                                            "/event/download/relatorio/downloads",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-file-download-outline" />
                                        {!showLabels ? null : (
                                          <span>Relatório de downloads</span>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                )}

                                {checkItemMenuExists("FEED") && (
                                  <a
                                    className={
                                      props.state.events === "14"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("14", "FEED");
                                      closeDrops("");

                                      navigate("/event/feed", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="mdi mdi-post" />
                                    {!showLabels ? null : <span>Feed</span>}
                                  </a>
                                )}

                                {/* {checkItemMenuExists("GRUPOS") && (
                            <a
                              className={
                                props.state.events === "19" ? "selected" : ""
                              }
                              onClick={() => {
                                props.openEvent("19");
                                closeDrops("");
                                navigate("/event/grupos", {
                                  state: { ...location?.state },
                                });
                              }}
                            >
                              <i className="bx bxs-group" />
                              {!showLabels ? null : (
                                <span>Grupos</span>
                              )}
                            </a>
                          )} */}

                                {checkItemMenuExists("MENU_APP") && (
                                  <a
                                    className={
                                      props.state.events === "20"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("20", "MENU_APP");
                                      closeDrops("");

                                      navigate("/event/menu", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-menu-alt-left" />
                                    {!showLabels ? null : (
                                      <span>Menu do App</span>
                                    )}
                                  </a>
                                )}
                                {checkItemMenuExists("NOTIFICACOES_PUSH") && (
                                  <a
                                    className={
                                      props.state.events === "21"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "21",
                                        "NOTIFICACOES_PUSH",
                                      );
                                      closeDrops("");

                                      navigate("/event/notifications", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-notification" />
                                    {!showLabels ? null : (
                                      <span>Notificações Push</span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("PALESTRANTES") && (
                                  <a
                                    className={
                                      props.state.events === "49"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("49", "PALESTRANTES");
                                      closeDrops("");

                                      navigate("/event/palestrantes", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="fa fa-users" />
                                    {!showLabels ? null : (
                                      <span>Palestrantes</span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists(
                                  "QUESTIONARIO_RELATORIO_RESPOSTAS",
                                ) && (
                                  <a
                                    className="waves-effect"
                                    onClick={() => {
                                      closeDrops("questionario");
                                    }}
                                  >
                                    <i className="mdi mdi-clipboard-edit-outline" />
                                    {!showLabels ? null : (
                                      <span>Questionários</span>
                                    )}
                                    {openSection === "questionario" ? (
                                      <i className="bx bx-chevron-up" />
                                    ) : (
                                      <i className="bx bx-chevron-down" />
                                    )}
                                  </a>
                                )}
                                {openSection === "questionario" && (
                                  <div className="submenu-tree">
                                    {checkItemMenuExists(
                                      "QUESTIONARIO_RELATORIO_RESPOSTAS",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "22"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "22",
                                            "QUESTIONARIO_RELATORIO_RESPOSTAS",
                                          );

                                          navigate(
                                            "/event/questionario/relatorio",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-view-list" />
                                        {!showLabels ? null : (
                                          <span>Relatórios de Respostas</span>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                )}

                                {checkItemMenuExists("SUPER_TELA") && (
                                  <a
                                    className={
                                      props.state.events === "23"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("23", "SUPER_TELA");
                                      closeDrops("");

                                      navigate("/event/superTela", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className=" bx bxl-youtube" />
                                    {!showLabels ? null : (
                                      <span>Super Tela</span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists(
                                  "UPLOADAPP_RELATORIO_PARTICIPANTES",
                                ) && (
                                  <a
                                    className="waves-effect"
                                    onClick={() => {
                                      closeDrops("uploadapp");
                                    }}
                                  >
                                    <i className="mdi mdi-cloud-upload" />
                                    {!showLabels ? null : <span>Uploads</span>}
                                    {openSection === "uploadapp" ? (
                                      <i className="bx bx-chevron-up" />
                                    ) : (
                                      <i className="bx bx-chevron-down" />
                                    )}
                                  </a>
                                )}
                                {openSection === "uploadapp" && (
                                  <div className="submenu-tree">
                                    {checkItemMenuExists(
                                      "UPLOADAPP_RELATORIO_PARTICIPANTES",
                                    ) && (
                                      <a
                                        className={
                                          props.state.events === "24"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "24",
                                            "UPLOADAPP_RELATORIO_PARTICIPANTES",
                                          );

                                          navigate("/event/upload/relatorio", {
                                            state: { ...location?.state },
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-view-list" />
                                        {!showLabels ? null : (
                                          <span>
                                            Relatório por Participante
                                          </span>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section Coletor de Leads */}
                      {checkProductExists("Coletor de Leads") &&
                        (checkItemMenuExists("STANDS") ||
                          checkItemMenuExists("RELATORIOS LEADS") ||
                          checkItemMenuExists("CONFIGURACOESLEADS")) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("leadCollector");
                              }}
                            >
                              {props.t("Coletor de Leads")}
                              {openProduct === "leadCollector" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "leadCollector" && (
                              <div className="product-section-open">
                                <div className="submenu-tree">
                                  {checkItemMenuExists("STANDS") && (
                                    <a
                                      className={
                                        props.state.events === "46"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent("46", "STANDS");

                                        navigate(
                                          "/event/leadCollector/stands",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-home-variant-outline" />
                                      {!showLabels ? null : <span>Stands</span>}
                                    </a>
                                  )}
                                  {checkItemMenuExists("RELATORIOS LEADS") && (
                                    <a
                                      className={
                                        props.state.events === "47"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent(
                                          "47",
                                          "RELATORIOS LEADS",
                                        );

                                        navigate(
                                          "/event/leadCollector/reports",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-chart-bar" />
                                      {!showLabels ? null : (
                                        <span>Relatório</span>
                                      )}
                                    </a>
                                  )}
                                  {checkItemMenuExists(
                                    "CONFIGURACOESLEADS",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "48"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent("48");

                                        navigate(
                                          "/event/leadCollector/configurations",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-cog-outline" />
                                      {!showLabels ? null : (
                                        <span>Configurações</span>
                                      )}
                                    </a>
                                  )}
                                </div>
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section Credenciamento */}
                      {checkProductExists("Credenciamento") &&
                        profile === process.env.REACT_APP_PMCODE && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("accreditationPages");
                              }}
                            >
                              {props.t("Credenciamento")}
                              {openProduct === "accreditationPages" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "accreditationPages" && (
                              <div className="product-section-open">
                                <div className="submenu-tree">
                                  {checkItemMenuExists(
                                    "CONFIGURACOES_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "53"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent(
                                          "53",
                                          "CONFIGURACOES_CREDENCIAMENTO",
                                        );

                                        navigate(
                                          "/event/accreditation/configurations",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-cog-outline" />
                                      {!showLabels ? null : (
                                        <span>Configurações</span>
                                      )}
                                    </a>
                                  )}

                                  {checkItemMenuExists(
                                    "USUARIOS_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "54"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent("54", "USUARIOS");

                                        navigate("/event/accreditation/users", {
                                          state: { ...location?.state },
                                        });
                                      }}
                                    >
                                      <i className="mdi mdi-account" />
                                      {!showLabels ? null : (
                                        <span>Usuários</span>
                                      )}
                                    </a>
                                  )}

                                  {checkItemMenuExists(
                                    "ACOES_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "55"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent("55", "ACOES");

                                        navigate(
                                          "/event/accreditation/actions",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-whatsapp" />
                                      {!showLabels ? null : <span>Ações</span>}
                                    </a>
                                  )}

                                  {checkItemMenuExists(
                                    "ETIQUETASZ_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "56"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent(
                                          "56",
                                          "ZEBRA_TAG_MAKER",
                                        );

                                        navigate(
                                          "/event/accreditation/zebra-tag-maker",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-barcode" />
                                      {!showLabels ? null : (
                                        <span>Etiquetas Zebra</span>
                                      )}
                                    </a>
                                  )}

                                  {checkItemMenuExists(
                                    "FACEID_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "57"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent(
                                          "57",
                                          "FACE_RECOGNITION_REPORT",
                                        );

                                        navigate(
                                          "/event/accreditation/face-recognition-report",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-face-recognition" />
                                      {!showLabels ? null : (
                                        <span>Cadastros de Face ID</span>
                                      )}
                                    </a>
                                  )}
                                  <a
                                    className={
                                      props.state.events === "59"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "59",
                                        "FACE_RECOGNITION_CONFIG",
                                      );

                                      navigate(
                                        "/event/accreditation/face-recognition-config",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                  >
                                    <i className="mdi mdi-account-cog" />
                                    {!showLabels ? null : (
                                      <span>Configurações de Face ID</span>
                                    )}
                                  </a>

                                  {checkItemMenuExists(
                                    "CHECKINS_CREDENCIAMENTO",
                                  ) && (
                                    <a
                                      className={
                                        props.state.events === "61"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent(
                                          "61",
                                          "SCHEDULE_CHECKIN_REPORT",
                                        );

                                        navigate(
                                          "/event/accreditation/schedule-checkin-report",
                                          {
                                            state: { ...location?.state },
                                          },
                                        );
                                      }}
                                    >
                                      <i className="mdi mdi-calendar-check" />
                                      {!showLabels ? null : (
                                        <span>Relatório de Check-ins</span>
                                      )}
                                    </a>
                                  )}

                                  {checkItemMenuExists(
                                    "RELATORIO_PARTICIPANTE_CREDENCIAMENTO",
                                  ) && (
                                    <>
                                      <a
                                        className={
                                          props.state.events === "62"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "62",
                                            "GUESTS_REPORT_PAGE",
                                          );

                                          navigate(
                                            "/event/accreditation/guests-report-page",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-calendar-account-outline" />
                                        {!showLabels ? null : (
                                          <span>
                                            Relatório de Participantes
                                          </span>
                                        )}
                                      </a>
                                      <a
                                        className={
                                          props.state.events === "63"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent(
                                            "63",
                                            "RELATORIO_NUMERO_UNICO_CREDENCIAMENTO",
                                          );

                                          navigate(
                                            "/event/accreditation/guest-unique-number-report",
                                            {
                                              state: { ...location?.state },
                                            },
                                          );
                                        }}
                                      >
                                        <i className="mdi mdi-numeric" />
                                        {!showLabels ? null : (
                                          <span>Relatório de Número Único</span>
                                        )}
                                      </a>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </section>
                        )}

                      {checkProductExists("Distribuição de Cotas") &&
                        checkItemMenuExists("SORTEIO_COTAS") && (
                          <>
                            <section>
                              <li
                                className="menu-subtitle product-drop"
                                onClick={() => {
                                  toggleProduct("quotas");
                                }}
                              >
                                {props.t("Distribuição de Cotas")}
                                {openProduct === "quotas" ? (
                                  <i className="bx bx-chevron-up icon-product-drop" />
                                ) : (
                                  <i className="bx bx-chevron-down icon-product-drop" />
                                )}
                              </li>

                              {openProduct === "quotas" && (
                                <div className="product-section-open">
                                  {checkItemMenuExists("SORTEIO_COTAS") && (
                                    <a
                                      className={
                                        props.state.events === "7"
                                          ? "selected waves-effect"
                                          : "waves-effect"
                                      }
                                      onClick={() => {
                                        props.openEvent("7", "SORTEIO_COTAS");
                                        closeDrops("");
                                        navigate("/event/sorteio", {
                                          state: { ...location?.state },
                                        });
                                      }}
                                      style={{ display: "flex" }}
                                    >
                                      <i className="mdi mdi-dice-multiple" />
                                      {!showLabels ? null : (
                                        <span className="option-drop-menu">
                                          Sorteios
                                        </span>
                                      )}
                                    </a>
                                  )}
                                </div>
                              )}
                            </section>
                          </>
                        )}

                      {checkProductExists("Leitor de QR Code") &&
                        (checkItemMenuExists("CRIAR QR CODE") ||
                          checkItemMenuExists(
                            "RELATORIO POR PARTICIPANTES(QR CODE)",
                          )) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("leitorQrcode");
                              }}
                            >
                              {props.t("Leitor de QR Code")}
                              {openProduct === "leitorQrcode" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "leitorQrcode" && (
                              <div className="submenu-tree">
                                {checkItemMenuExists("CRIAR QR CODE") && (
                                  <a
                                    className={
                                      props.state.events === "15"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("15", "CRIAR QR CODE");

                                      navigate("/event/functions", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-code-block" />
                                    {!showLabels ? null : (
                                      <span>Criar QR Code</span>
                                    )}
                                  </a>
                                )}
                                {checkItemMenuExists(
                                  "RELATORIO POR PARTICIPANTES(QR CODE)",
                                ) && (
                                  <a
                                    className={
                                      props.state.events === "16"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "16",
                                        "RELATORIO POR PARTICIPANTES(QR CODE)",
                                      );

                                      navigate("/event/functions/relatorio", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bxs-report" />
                                    {!showLabels ? null : (
                                      <span>Relatório por Participantes</span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section MATCH */}
                      {checkItemMenuExists("RELATORIO_HOSPEDAGEM") &&
                        checkProductExists("Match de Hospedagem") && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("match");
                              }}
                            >
                              {props.t("Match de Hospedagem")}
                              {openProduct === "match" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "match" && (
                              <div className="product-section-open">
                                {checkItemMenuExists(
                                  "RELATORIO_HOSPEDAGEM",
                                ) && (
                                  <a
                                    className={
                                      props.state.events === "25"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "25",
                                        "RELATORIO_HOSPEDAGEM",
                                      );
                                      closeDrops("");
                                      navigate("/event/match/relatorio", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-view-list" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Relatório de Hospedagem
                                      </span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section Portal Boticário */}
                      {(checkItemMenuExists("COTASDEPARTAMENTO") ||
                        checkItemMenuExists("COTASPORCP") ||
                        checkItemMenuExists("PACOTESQUARTO") ||
                        checkItemMenuExists("EVENTOSXGRUPOS") ||
                        checkItemMenuExists("EVENTOS_HABILITADOS")) &&
                        checkProductExists("Portal Boticário") && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("portalBoticario");
                              }}
                            >
                              {props.t("Portal Boticário")}
                              {openProduct === "portalBoticario" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "portalBoticario" && (
                              <div className="product-section-open">
                                {checkItemMenuExists("COTASDEPARTAMENTO") && (
                                  <a
                                    className={
                                      props.state.events === "42"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "42",
                                        "COTASDEPARTAMENTO",
                                      );
                                      closeDrops("");
                                      navigate(
                                        "/event/portalboticario/quotas-departament",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-office-building" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Cotas por Departamento
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("COTASPORCP") && (
                                  <a
                                    className={
                                      props.state.events === "43"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("43", "COTASPORCP");
                                      closeDrops("");
                                      navigate(
                                        "/event/portalboticario/quotas-cp",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-account-group" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Cotas por CP
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("PACOTESQUARTO") && (
                                  <a
                                    className={
                                      props.state.events === "45"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("45", "PACOTESQUARTO");
                                      closeDrops("");
                                      navigate(
                                        "/event/portalboticario/packages",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-bed" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Pacotes de Quarto
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("EVENTOSXGRUPOS") && (
                                  <a
                                    className={
                                      props.state.events === "58"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent("58", "EVENTOSXGRUPOS");
                                      closeDrops("");
                                      navigate(
                                        "/event/portalboticario/events-x-groups",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-link-variant" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Eventos x Grupos
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("EVENTOS_HABILITADOS") && (
                                  <a
                                    className={
                                      props.state.events === "60"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "60",
                                        "EVENTOS_HABILITADOS",
                                      );
                                      closeDrops("");
                                      navigate(
                                        "/event/portalboticario/enabled-events",
                                        {
                                          state: { ...location?.state },
                                        },
                                      );
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-calendar-check" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Eventos Habilitados
                                      </span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {(checkItemMenuExists("CONFIGURARPORTALEVENTO") ||
                        checkItemMenuExists("MENUDOPORTAL")) &&
                        checkProductExists("Portal de Eventos") && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("portalEventos");
                              }}
                            >
                              {props.t("Portal de Eventos")}
                              {openProduct === "portalEventos" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "portalEventos" && (
                              <div className="product-section-open">
                                {checkItemMenuExists(
                                  "CONFIGURARPORTALEVENTO",
                                ) && (
                                  <a
                                    className={
                                      props.state.events === "43"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      closeDrops("");
                                      closeMobileMenu();
                                      setModalConfigEventPortal(true);
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-cog-outline" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Configurar Evento
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("MENUDOPORTAL") &&
                                  profile === process.env.REACT_APP_PMCODE && (
                                    <a
                                      className={
                                        props.state.events === "50"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        props.openEvent("50", "MENUDOPORTAL");
                                        closeDrops("");
                                        navigate("/event/portal-eventos", {
                                          state: { ...location?.state },
                                        });
                                      }}
                                      style={{ display: "flex" }}
                                    >
                                      <i className="bx bx-menu-alt-left" />
                                      {!showLabels ? null : (
                                        <span className="option-drop-menu">
                                          Menu do Portal
                                        </span>
                                      )}
                                    </a>
                                  )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section Relatório Personalizado */}
                      {checkProductExists("Relatórios Personalizados") && (
                        <section>
                          <li
                            className="menu-subtitle product-drop"
                            onClick={() => {
                              toggleProduct("relatorioPersonalizado");
                            }}
                          >
                            {props.t("Relatório Personalizado")}
                            {openProduct === "relatorioPersonalizado" ? (
                              <i className="bx bx-chevron-up icon-product-drop" />
                            ) : (
                              <i className="bx bx-chevron-down icon-product-drop" />
                            )}
                          </li>

                          {openProduct === "relatorioPersonalizado" && (
                            <div className="product-section-open">
                              {checkItemMenuExists("DASHBOARDVIBRA") && (
                                <a
                                  className={
                                    props.state.events === "41"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    props.openEvent(
                                      "41",
                                      "RELATORIO_HOSPEDAGEM",
                                    );
                                    closeDrops("");
                                    navigate(
                                      "/event/customReport/dashboard-vibra",
                                      {
                                        state: { ...location?.state },
                                      },
                                    );
                                  }}
                                  style={{ display: "flex" }}
                                >
                                  <i className="mdi mdi-view-list" />
                                  {!showLabels ? null : (
                                    <span className="option-drop-menu">
                                      Dashboard Vibra
                                    </span>
                                  )}
                                </a>
                              )}

                              {checkItemMenuExists("EXCLUSAOUSUARIOVIBRA") && (
                                <a
                                  className={
                                    props.state.events === "99"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    props.openEvent(
                                      "99",
                                      "EXCLUSAOUSUARIOVIBRA",
                                    );
                                    closeDrops("");
                                    navigate(
                                      "/event/customReport/exclusao-usuario-vibra",
                                      {
                                        state: { ...location?.state },
                                      },
                                    );
                                  }}
                                  style={{ display: "flex" }}
                                >
                                  <i className="mdi mdi-account-remove" />
                                  {!showLabels ? null : (
                                    <span className="option-drop-menu">
                                      Exclusão de Usuário
                                    </span>
                                  )}
                                </a>
                              )}

                              {checkItemMenuExists("GAMERDNOTAVEIS") && (
                                <a
                                  className={
                                    props.state.events === "52"
                                      ? "selected waves-effect"
                                      : "waves-effect"
                                  }
                                  onClick={() => {
                                    props.openEvent("52", "GAMERD");

                                    navigate("/event/gameRD", {
                                      state: { ...location?.state },
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-gamepad-variant" />
                                  {!showLabels ? null : (
                                    <span>Game RD Estandes</span>
                                  )}
                                </a>
                              )}

                              {checkItemMenuExists("GAMERDPREWORK") && (
                                <a
                                  className={
                                    props.state.events === "59"
                                      ? "selected waves-effect"
                                      : "waves-effect"
                                  }
                                  onClick={() => {
                                    props.openEvent("59", "GAMERDPREWK");

                                    navigate("/event/gameRDPW", {
                                      state: { ...location?.state },
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-gamepad-variant" />
                                  {!showLabels ? null : (
                                    <span>Game RD Pré Work</span>
                                  )}
                                </a>
                              )}

                              {checkItemMenuExists("GAMESXSQUAD") && (
                                <a
                                  className={
                                    props.state.events === "64"
                                      ? "selected waves-effect"
                                      : "waves-effect"
                                  }
                                  onClick={() => {
                                    props.openEvent("64", "GAMESXSQUAD");

                                    navigate(
                                      "/event/customReport/games-x-squad",
                                      {
                                        state: { ...location?.state },
                                      },
                                    );
                                  }}
                                >
                                  <i className="mdi mdi-gamepad-variant" />
                                  {!showLabels ? null : (
                                    <span>Games X-Squad</span>
                                  )}
                                </a>
                              )}
                            </div>
                          )}
                        </section>
                      )}

                      {/* Section RSVP */}
                      {checkProductExists("RSVP") &&
                        (checkItemMenuExists("FORMULARIO_DINAMICO") ||
                          checkItemMenuExists("NOTIFICACOES_PUSH") ||
                          checkItemMenuExists("EMAIL") ||
                          checkItemMenuExists("PAGINA_WEB")) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("rsvp");
                              }}
                            >
                              {props.t("RSVP")}
                              {openProduct === "rsvp" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "rsvp" && (
                              <div className="product-section-open">
                                {checkItemMenuExists("FORMULARIO_DINAMICO") && (
                                  <a
                                    className={
                                      props.state.events === "26"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      closeDrops("");
                                      props.openEvent(
                                        "26",
                                        "FORMULARIO_DINAMICO",
                                      );
                                      navigate("/event/rsvp/formulario", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-badge-check" />
                                    {!showLabels ? null : (
                                      <span>Formulários</span>
                                    )}
                                  </a>
                                )}

                                {(checkItemMenuExists("EMAIL") ||
                                  checkItemMenuExists("PAGINA_WEB")) && (
                                  <a
                                    className="waves-effect"
                                    onClick={() => {
                                      closeDrops("templates");
                                    }}
                                  >
                                    <i className="fa-solid fa-code" />
                                    {!showLabels ? null : (
                                      <span>Templates</span>
                                    )}
                                    {dropTemplates ? (
                                      <i className="bx bx-chevron-up" />
                                    ) : (
                                      <i className="bx bx-chevron-down" />
                                    )}
                                  </a>
                                )}
                                {dropTemplates && (
                                  <div className="submenu-tree">
                                    {checkItemMenuExists("EMAIL") && (
                                      <a
                                        className={
                                          props.state.events === "27"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent("27", "EMAIL");
                                          navigate("/event/templates/email", {
                                            state: { ...location?.state },
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-email" />
                                        {!showLabels ? null : (
                                          <span>Email</span>
                                        )}
                                      </a>
                                    )}
                                    {checkItemMenuExists("PAGINA_WEB") && (
                                      <a
                                        className={
                                          props.state.events === "28"
                                            ? "selected waves-effect"
                                            : "waves-effect"
                                        }
                                        onClick={() => {
                                          props.openEvent("28", "PAGINA_WEB");
                                          navigate("/event/templates/web", {
                                            state: { ...location?.state },
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-web" />
                                        {!showLabels ? null : (
                                          <span>Página WEB</span>
                                        )}
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </section>
                        )}

                      {/* Section GATEWAY DE PAGAMENTO */}
                      {checkProductExists("Gateway de Pagamentos (Adesão)") &&
                        (checkItemMenuExists("CUPONS") ||
                          checkItemMenuExists("DASHBOARD_VENDAS") ||
                          checkItemMenuExists("INGRESSOS") ||
                          checkItemMenuExists("SPLITS") ||
                          checkItemMenuExists("VENDAS_CONSOLIDADAS")) && (
                          <section>
                            <li
                              className="menu-subtitle product-drop"
                              onClick={() => {
                                toggleProduct("ticket");
                              }}
                            >
                              {props.t("TICKETEIRA")}
                              {openProduct === "ticket" ? (
                                <i className="bx bx-chevron-up icon-product-drop" />
                              ) : (
                                <i className="bx bx-chevron-down icon-product-drop" />
                              )}
                            </li>

                            {openProduct === "ticket" && (
                              <div className="product-section-open">
                                {checkItemMenuExists("CUPONS") && (
                                  <a
                                    className={
                                      props.state.events === "30"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("30", "CUPONS");
                                      closeDrops("");
                                      navigate("/event/cupons", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="fas fa-ticket-alt" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Cupons
                                      </span>
                                    )}
                                  </a>
                                )}
                                {checkItemMenuExists("DASHBOARD_VENDAS") && (
                                  <a
                                    className={
                                      props.state.events === "31"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("31", "DASHBOARD_VENDAS");
                                      closeDrops("");
                                      navigate("/event/dashboard-tupperware", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="bx bxs-pie-chart-alt-2" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Dashboard de Vendas
                                      </span>
                                    )}
                                  </a>
                                )}
                                {checkItemMenuExists("INGRESSOS") && (
                                  <a
                                    className={
                                      props.state.events === "32"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("32", "INGRESSOS");
                                      closeDrops("");
                                      navigate("/event/tickets", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-ticket-outline" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Ingressos
                                      </span>
                                    )}
                                  </a>
                                )}
                                {checkItemMenuExists("SPLITS") && (
                                  <a
                                    className={
                                      props.state.events === "33"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent("33", "SPLITS");
                                      closeDrops("");
                                      navigate("/event/splits", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="mdi mdi-call-split" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Splits
                                      </span>
                                    )}
                                  </a>
                                )}

                                {checkItemMenuExists("VENDAS_CONSOLIDADAS") && (
                                  <a
                                    className={
                                      props.state.events === "35"
                                        ? "selected waves-effect"
                                        : "waves-effect"
                                    }
                                    onClick={() => {
                                      props.openEvent(
                                        "35",
                                        "VENDAS_CONSOLIDADAS",
                                      );
                                      closeDrops("");
                                      navigate("/event/vendas-consolidadas", {
                                        state: { ...location?.state },
                                      });
                                    }}
                                    style={{ display: "flex" }}
                                  >
                                    <i className="bx bx-money" />
                                    {!showLabels ? null : (
                                      <span className="option-drop-menu">
                                        Vendas Consolidadas
                                      </span>
                                    )}
                                  </a>
                                )}
                              </div>
                            )}
                          </section>
                        )}
                    </div>
                  )}

                  {/* <Link to="/historic" className="waves-effect">
                    <i className="bx bx-history"></i>
                    {!showLabels ? null : (
                      <span>Histórico</span>
                    )}
                  </Link> */}
                  {(checkItemMenuExists("INTEEGRA_CREATOR") ||
                    checkItemMenuExists("INTEEGRA_DRIVE") ||
                    checkItemMenuExists("TIPOS_DE_EVENTO") ||
                    checkItemMenuExists("PERFIS") ||
                    checkItemMenuExists("USUARIOS") ||
                    checkItemMenuExists("CONFIGURARPORTALCONTRATO")) && (
                    <a
                      className="waves-effect"
                      onClick={() => {
                        closeDrops("configuration");
                      }}
                    >
                      <i className="dripicons-gear" />
                      {!showLabels ? null : (
                        <span className="option-drop-menu">Configurações</span>
                      )}
                      {props.state.menu.menuConfig ? (
                        <i className="bx bx-chevron-up" />
                      ) : (
                        <i className="bx bx-chevron-down" />
                      )}
                    </a>
                  )}
                  {props.state.menu.menuConfig && (
                    <div className="submenu-tree">
                      {checkItemMenuExists("CONFIGURARPORTALCONTRATO") && (
                        <a
                          className={
                            location.pathname === "/event/criar-portal"
                              ? "selected waves-effect"
                              : "waves-effect"
                          }
                          onClick={() => {
                            props.openEvent("51", "CONFIGURARPORTALCONTRATO");
                            navigate("/event/criar-portal", {
                              state: { ...location?.state },
                            });
                          }}
                        >
                          <i className="bx bx-layout" />
                          {!showLabels ? null : <span>Criar Portal</span>}
                        </a>
                      )}
                      {/* {checkItemMenuExists("CONFIGURARPORTALCONTRATO") && (
                        <a
                          className={"waves-effect"}
                          onClick={() => setModalConfigPortal(true)}
                        >
                          <i className="dripicons-gear" />
                          {!showLabels ? null : (
                            <span>Configurar Portal</span>
                          )}
                        </a>
                      )} */}
                      {checkItemMenuExists("INTEEGRA_CREATOR") && (
                        <Link
                          to="/inteegra-creator"
                          className={`waves-effect ${
                            location.pathname === "/inteegra-creator"
                              ? "selected"
                              : null
                          }`}
                          onClick={() => props.closeMenuApp()}
                        >
                          <i
                            className="mdi mdi-language-html5"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "color",
                                  "#495057",
                                  "important",
                                );
                              }
                            }}
                          />
                          {!showLabels ? null : <span>Inteegra Creator</span>}
                        </Link>
                      )}
                      {checkItemMenuExists("INTEEGRA_DRIVE") && (
                        <Link
                          to="/inteegra-drive"
                          className={`waves-effect ${
                            location.pathname === "/inteegra-drive"
                              ? "selected"
                              : null
                          }`}
                          onClick={() => props.closeMenuApp()}
                        >
                          <i
                            className="bx bx-image"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "color",
                                  "#495057",
                                  "important",
                                );
                              }
                            }}
                          />
                          {!showLabels ? null : <span>Inteegra Drive</span>}
                        </Link>
                      )}
                      {/* {checkItemMenuExists("TEMPLATES") && (
                        <Link
                          to="/templates"
                          className={`waves-effect ${
                            (location.pathname === "/templates" ||
                              location.pathname === "/html-editor") &&
                            props.state.events === "34"
                              ? "selected"
                              : null
                          }`}
                          onClick={() => {
                            props.openEvent("34");
                            props.closeMenuApp();
                          }}
                        >
                          <i
                            className="fa-solid fa-code"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "color",
                                  "#495057",
                                  "important"
                                );
                              }
                            }}
                          />
                          {!showLabels ? null : (
                            <span>Templates</span>
                          )}
                        </Link>
                      )} */}

                      {checkItemMenuExists("PERFIS") &&
                        (profile === process.env.REACT_APP_PMCODE ||
                          profile ===
                            "f741a40e-e696-420a-a05e-06efbdd2ae20") && (
                          <Link
                            to="/profiles"
                            className={`waves-effect ${
                              location.pathname === "/profiles"
                                ? "selected"
                                : null
                            }`}
                            onClick={() => props.closeMenuApp()}
                          >
                            <i className="bx bxs-group" />
                            {!showLabels ? null : <span>Perfis</span>}
                          </Link>
                        )}

                      {checkItemMenuExists("STATUS_RSVP") && (
                        <Link
                          to="/status-rsvp"
                          className={`waves-effect ${
                            location.pathname === "/status-rsvp"
                              ? "selected"
                              : null
                          }`}
                          onClick={() => props.closeMenuApp()}
                        >
                          <i className="bx bx-list-check" />
                          {!showLabels ? null : <span>Status RSVP</span>}
                        </Link>
                      )}

                      {checkItemMenuExists("TIPOS_DE_EVENTO") && (
                        <Link
                          to="/type-event"
                          className={`waves-effect ${
                            location.pathname === "/type-event"
                              ? "selected"
                              : null
                          }`}
                          onClick={() => props.closeMenuApp()}
                        >
                          <i className="bx bx-notepad" />
                          {!showLabels ? null : <span>Tipos de Evento</span>}
                        </Link>
                      )}

                      {checkItemMenuExists("USUARIOS") &&
                        (profile === process.env.REACT_APP_PMCODE ||
                          profile ===
                            "f741a40e-e696-420a-a05e-06efbdd2ae20") && (
                          <Link
                            to="/users"
                            className={`waves-effect ${
                              location.pathname === "/users" ? "selected" : null
                            }`}
                            onClick={() => props.closeMenuApp()}
                          >
                            {/* <Link to="/users" className="waves-effect selected"> */}

                            <i className="mdi mdi-account-circle-outline"></i>
                            {!showLabels ? null : <span>Usuários</span>}
                          </Link>
                        )}
                    </div>
                  )}
                  {/* {checkIcMenu() && ( */}
                  {profile === process.env.REACT_APP_PMCODE && (
                    <a
                      className="waves-effect"
                      onClick={() => {
                        closeDrops("contract");
                      }}
                    >
                      <i className="dripicons-gear" />
                      {!showLabels ? null : (
                        <span className="option-drop-menu">Contratos</span>
                      )}
                      {props.state.menu.menuContract ? (
                        <i className="bx bx-chevron-up" />
                      ) : (
                        <i className="bx bx-chevron-down" />
                      )}
                    </a>
                  )}
                  {props.state.menu.menuContract && (
                    <div className="submenu-tree">
                      {/* {checkIcMenu() && ( */}
                      {profile === process.env.REACT_APP_PMCODE && (
                        // checkProductExists("APP Eventos Plus") && (
                        <a
                          className="waves-effect"
                          onClick={() => closeDrops("applications")}
                        >
                          <i
                            className="mdi mdi-apps"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "color",
                                  "#495057",
                                  "important",
                                );
                              }
                            }}
                          />
                          {!showLabels ? null : (
                            <span className="option-drop-menu">
                              Aplicativos
                            </span>
                          )}
                          {props.state.menu.menuApp ? (
                            <i className="bx bx-chevron-up" />
                          ) : (
                            <i className="bx bx-chevron-down" />
                          )}
                        </a>
                      )}
                      {props.state.menu.menuApp && (
                        <div className="submenu-tree">
                          {/* {checkIcMenu() && ( */}
                          {profile === process.env.REACT_APP_PMCODE && (
                            // checkItemMenuExists("APP_EVENTOS_PLUS") && (
                            // checkProductExists("APP Eventos Plus") && (
                            <Link
                              to="/mobile-apps"
                              className={`waves-effect ${
                                location.pathname === "/mobile-apps"
                                  ? "selected"
                                  : null
                              }`}
                            >
                              <i
                                className="mdi mdi-cellphone"
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty(
                                      "color",
                                      "#495057",
                                      "important",
                                    );
                                  }
                                }}
                              />
                              {!showLabels ? null : <span>Versões do App</span>}
                            </Link>
                          )}
                          {/* {checkIcMenu() && ( */}
                          {profile === process.env.REACT_APP_PMCODE && (
                            // checkItemMenuExists("APP_EVENTOS_PLUS") && (
                            <Link
                              to="/dictionary"
                              className={`waves-effect ${
                                location.pathname === "/dictionary"
                                  ? "selected"
                                  : null
                              }`}
                            >
                              <i
                                className="bx bx-book-open"
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty(
                                      "color",
                                      "#495057",
                                      "important",
                                    );
                                  }
                                }}
                              />
                              {!showLabels ? null : <span>Dicionário</span>}
                            </Link>
                          )}
                        </div>
                      )}

                      {/* {checkIcMenu() && ( */}
                      {profile === process.env.REACT_APP_PMCODE && (
                        <Link
                          to="/contracts"
                          onClick={() => props.closeMenuApp()}
                          className={`waves-effect ${
                            location.pathname === "/contracts"
                              ? "selected"
                              : null
                          }`}
                        >
                          <i
                            className="bx bx-file"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "color",
                                  "#495057",
                                  "important",
                                );
                              }
                            }}
                          />
                          {!showLabels ? null : <span>Contratos</span>}
                        </Link>
                      )}
                    </div>
                  )}

                  {profile === process.env.REACT_APP_PMCODE && (
                    <a
                      className="waves-effect"
                      onClick={() => {
                        closeDrops("documents");
                      }}
                    >
                      <i className="mdi mdi-file-cabinet" />
                      {!showLabels ? null : (
                        <span className="option-drop-menu">Documentação</span>
                      )}
                      {openSection === "documents" ? (
                        <i className="bx bx-chevron-up" />
                      ) : (
                        <i className="bx bx-chevron-down" />
                      )}
                    </a>
                  )}
                  {openSection === "documents" && (
                    <div className="submenu-tree">
                      <a
                        href="https://s3.amazonaws.com/bucket.app.eventos/gallery/8029badb-d64c-4af8-9f52-59b60e346767/2023/e8925f6a-872c-4905-8ce0-7535874fb470.pdf?AWSAccessKeyId=AKIA57MDOGUHNXCD6MBI&Expires=2043168801&Signature=y6amrOh6%2B%2BEJ%2FbZDMie1DGI36wA%3D"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="mdi mdi-text-box-outline" />
                        {!showLabels ? null : (
                          <span>Especificação APP Eventos</span>
                        )}
                      </a>

                      <a
                        href="https://s3.amazonaws.com/bucket.app.eventos/gallery/8029badb-d64c-4af8-9f52-59b60e346767/2023/96d3d342-2f0f-4792-b4fe-fd40bc90cfbd.pdf?AWSAccessKeyId=AKIA57MDOGUHNXCD6MBI&Expires=2043168801&Signature=hoq11ihLDfcObEmM07KBqssWhrw%3D"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="mdi mdi-text-box-outline" />
                        {!showLabels ? null : (
                          <span>Especificação Match de Hospedagem</span>
                        )}
                      </a>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    openEvent: (data, activeScreenName = null) => {
      return dispatch({
        type: "OPEN_EVENT_MENU",
        data,
        activeScreenName,
      });
    },
    openNavBar: (data) => {
      return dispatch({ type: "OPEN_GLOBAL_LAYOUT_MENU_NAV_WEB", data });
    },
    closeNavBar: (data) => {
      return dispatch({ type: "CLOSE_GLOBAL_LAYOUT_MENU_NAV_WEB", data });
    },
    openMenuConfig: () => {
      return dispatch({
        type: "open_menuConfig",
      });
    },
    closeMenuConfig: () => {
      return dispatch({
        type: "close_menuConfig",
      });
    },
    openMenuApp: () => {
      return dispatch({
        type: "open_menuApp",
      });
    },
    closeMenuApp: () => {
      return dispatch({
        type: "close_menuApp",
      });
    },
    openMenuContracts: () => {
      return dispatch({
        type: "OPEN_MENU_CONTRACTS",
      });
    },
    closeMenuContracts: () => {
      return dispatch({
        type: "CLOSE_MENU_CONTRACTS",
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SidebarContent));
